/****************************************************************************
 * COPYRIGHT (c) 2025 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/

import {FETCH_SUBMISSIONS_REQUEST, FETCH_SUBMISSIONS_SUCCESS, FETCH_SUBMISSIONS_FAILURE} from './ApplicationDetailsSubmissionsTypes';
import APIManager from '../../ApiManager/ApiManager';
import { COMMON_ERROR } from "../ApplicationDetailsError/ApplicationDetailsErrorTypes";


export const fetchSumissionsRequest = () => {
    return {
      type: FETCH_SUBMISSIONS_REQUEST,
    };
  };
  
  export const fetchSubmissionsSuccess = (submissions) => {
    return {
      type: FETCH_SUBMISSIONS_SUCCESS,
      payload: submissions,
    };
  };
  
  export const fetchSubmissionsFailure = (error) => {
    return {
      type: FETCH_SUBMISSIONS_FAILURE,
      payload: error,
    };
  };


  export const fetchAllSubmissions=(applicationId)=>{
    return async function (dispatch) {
        dispatch(fetchSumissionsRequest());
        try {
          const data = await APIManager.getAllSubmissions(applicationId)
          dispatch(fetchSubmissionsSuccess(data));
        } catch (error) {
          dispatch(fetchSubmissionsFailure(error));
          dispatch(commonError(error, FETCH_SUBMISSIONS_FAILURE));
        }
      };

  }

  export const commonError=(error,errorType)=>{
    return({
      type:COMMON_ERROR,
      payload:{
        message:error.message,
        errorType:errorType
      }
    })
  }


